import { Component, OnInit, Output, EventEmitter, HostListener } from '@angular/core';
import { Subscription } from 'rxjs';
import { AlarmService } from '../services/alarm.service';
import { Alarm } from 'src/models/alarm.model';
import { ricHandleStatus } from '../enums/ric-handle-status';
import { WEB_SOCKET_EVENTS } from '../enums/web-socket-events';
import { SocketService } from '../services/socket.service';

@Component({
  selector: 'app-alarm-tabs',
  templateUrl: './alarm-tabs.component.html',
  styleUrls: ['./alarm-tabs.component.scss']
})
export class AlarmTabsComponent implements OnInit {
  selectedTab: string = 'progress';
  @Output() tabSelected = new EventEmitter<string>();

  selectedAlarmSubscriber: Subscription;
  chatBotSelectedSubscriber: Subscription;
  public isContainZone: boolean = false;
  selectedAlarm: Alarm;
  isWorkflowHidden: boolean = false;
  activeTabSub: Subscription;
  isDisabledWorkflow: boolean = false;
  disabledWorkflowSub: Subscription;
  hasNewTaskNotification: boolean = false;

  constructor(public alarmService: AlarmService, private socketService: SocketService) { }

  ngOnInit(): void {
    this.selectedAlarmListener();
    this.chatBotSelectedListener();

    // Subscribe to tab changes
    this.activeTabSub = this.alarmService.activeTab$.subscribe((tabIndex: number) => {
      if (tabIndex === 1) {
        this.isWorkflowHidden = true;
      } else {
        this.isWorkflowHidden = false;
      }
    });

    this.disabledWorkflowSub = this.alarmService.getRicUpdates().subscribe((alarm: Alarm) => {
      if (alarm?._id === this?.selectedAlarm?.id) {
        this.updateWorkflowStatus(alarm.ricHandleStatus);
      }
    });

    this.webSocketInit();
  }

  selectedAlarmListener() {
    this.selectedAlarmSubscriber = this.alarmService.getOnAlarmSelectedListener().subscribe((alarm: Alarm) => {
      const activeTab = this.alarmService.getActiveTabIndex();
      if (alarm && (this.selectedAlarm?.id === alarm.id && activeTab === 0)) {
        return;
      }

      if (alarm) {
        this.selectedAlarm = alarm;
        this.isContainZone = this.alarmService.isContainZone(alarm);
        this.isDisabledWorkflow = true;
        this.updateWorkflowStatus(alarm.ricHandleStatus);
        if (this.selectedTab === 'zone') {
          this.selectTab('progress');
        } else if (this.selectedTab === 'workflow' && this.isWorkflowHidden) {
          this.selectTab('progress');
        }
      } else {
        this.selectedAlarm = null;
        this.isContainZone = false;
        this.selectTab('map');
      }
    });
  }

  private updateWorkflowStatus(status: ricHandleStatus) {
    this.isDisabledWorkflow = [
      ricHandleStatus.STARTED,
      ricHandleStatus.PENDING,
      ricHandleStatus.RUNNING
    ].includes(status);
  }

  chatBotSelectedListener() {
    this.chatBotSelectedSubscriber = this.alarmService.getChatBotSelectedListener().subscribe((selected: boolean) => {
      if (selected && !this.alarmService.isAskRamsysActive) {
        this.selectTab('chatbot');
      }
    });
  }

  selectTab(tab: string) {
    this.selectedTab = tab;
    this.tabSelected.emit(this.selectedTab);

    // Clear notification if "create-task" tab is selected
    if (tab === 'create-task') {
      this.hasNewTaskNotification = false;
    }
    this.alarmService.activeAlarmsTab = tab;
  }

  ngOnDestroy(): void {
    this.selectedAlarmSubscriber.unsubscribe();
    this.chatBotSelectedSubscriber.unsubscribe();
    this.activeTabSub.unsubscribe();
    this.disabledWorkflowSub.unsubscribe();
  }

  webSocketInit() {
    const socketId = localStorage.getItem('socketId');
    if (!socketId) {
      return;
    }
    const eventNotification = this.socketService.onEvent<any>(socketId);
    if (eventNotification) {
      eventNotification.subscribe((socketEvent) => {
        switch (socketEvent.type) {
          case WEB_SOCKET_EVENTS.NEW_TASK:
          case WEB_SOCKET_EVENTS.UPDATE_TASK:
            if (this.selectedTab !== 'create-task') {
              this.hasNewTaskNotification = true;
            }
            break;
          default:
        }
      });
    }
  }

}
